<nz-modal [nzTitle]="titleTpl" [(nzVisible)]="modalVisible" (nzOnOk)="handleOk()"
  [nzOkLoading]="okLoading"
  (nzOnCancel)="handleCancel()" nzOkText="Confirm" [nzOkDisabled]="loading">
  
  <ng-template #titleTpl>
    E-Invoice Details Confirmation
    <nz-tag nzColor="success" *ngIf="data.isLive">LIVE</nz-tag>
    <nz-tag nzColor="warning" *ngIf="!data.isLive"> SANDBOX</nz-tag>
  </ng-template>
    <ng-container *nzModalContent>
    <nz-spin [nzSpinning]="loading">
      <div class="text-primary">
        Do you confirm that the information provided is accurate and ready to be submitted to LHDN? Please review the
        details
        below before proceeding.
      </div>
      <nz-divider [nzText]="'Submit Option'" class="text-primary" [nzOrientation]="'left'"></nz-divider>
      <div class="text-center">
        <nz-radio-group name="submitMode" [(ngModel)]="submitMode">
          <label nz-radio [nzValue]="0">Submit by Item Lines</label>
          <label nz-radio [nzValue]="1">Submit by Item Classification</label>
        </nz-radio-group>
      </div>
      @if (isPurchase) 
      {
        <nz-divider [nzText]="supplierParty.companyName" [nzOrientation]="'left'"></nz-divider>
        <sv-container [col]="1" [size]="'small'" labelWidth="100">
          <sv label="Reg No." col="2">
            {{supplierParty.registrationNumber}}
          </sv>
          <sv label="TIN" col="2">
            {{supplierParty.tinNumber}}
          </sv>
          <sv label="Zip Code" col="2">
            {{supplierParty.zipCode}}
          </sv>
          <sv label="State" col="2">
            {{supplierParty.state}}
          </sv>
          <sv label="Country" col="2">
            {{supplierParty.countryName}}
          </sv>
          <sv label="Phone Number" col="2">
            {{supplierParty.phone1}}
          </sv>
          <sv label="Sales Tax Reg No." col="2">
            {{supplierParty.salesTaxRegNo}}
          </sv>
          <sv label="Service Tax Reg No." col="2">
            {{supplierParty.serviceTaxRegNo}}
          </sv>
          <sv-title>Address</sv-title>
          <sv [hideLabel]="true" col="1">
            <div *ngIf="supplierParty.address1">{{supplierParty.address1}}</div>
            <div *ngIf="supplierParty.address2">{{supplierParty.address2}}</div>
            <div *ngIf="supplierParty.address3">{{supplierParty.address3}}</div>
            <div *ngIf="supplierParty.address4">{{supplierParty.address4}}</div>
          </sv>
        </sv-container>
      } @else {
        <nz-divider [nzText]="customerParty.name" [nzOrientation]="'left'"></nz-divider>
        <sv-container [col]="1" [size]="'small'" labelWidth="100">
          <sv label="Reg No." col="2">
            {{customerParty.registrationNo}}
          </sv>
          <sv label="TIN" col="2">
            {{customerParty.tinNumber}}
          </sv>
          <sv label="Zip Code" col="2">
            {{customerParty.zipCode}}
          </sv>
          <sv label="State" col="2">
            {{customerParty.state}}
          </sv>
          <sv label="Country" col="2">
            {{customerParty.countryName}}
          </sv>
          <sv label="Phone Number" col="2">
            {{customerParty.phoneNo1}}
          </sv>
          <sv label="Sales Tax Reg No." col="2">
            {{customerParty.salesTaxRegNo}}
          </sv>
          <sv label="Service Tax Reg No." col="2">
            {{customerParty.serviceTaxRegNo}}
          </sv>
          <sv-title>Address</sv-title>
          <sv [hideLabel]="true" col="1">
            <div *ngIf="customerParty.address1">{{customerParty.address1}}</div>
            <div *ngIf="customerParty.address2">{{customerParty.address2}}</div>
            <div *ngIf="customerParty.address3">{{customerParty.address3}}</div>
            <div *ngIf="customerParty.address4">{{customerParty.address4}}</div>
          </sv>
        </sv-container>
      }
      
      <nz-divider [nzText]="'Summary'" [nzOrientation]="'left'"></nz-divider>
      <sv-container [col]="2">
        <sv label="Amount Exempted">
          <span class="float-right">
            {{data.amountExemptedFromTax|currency:data.currencyCode}}
          </span>
        </sv>
        <sv label="Subtotal">
          <span class="float-right">
            {{data.subtotalAmount|currency:data.currencyCode}}
          </span>
        </sv>
        <sv label="Total Discount">
          <span class="float-right">
            {{data.discountTotalAmount|currency:data.currencyCode}}
          </span>
        </sv>
        <sv label="Taxable">
          <span class="float-right">
            {{data.taxExclusiveTotalAmount|currency:data.currencyCode}}
          </span>
        </sv>
        <sv label="Tax">
          <span class="float-right">
            {{data.taxTotalAmount|currency:data.currencyCode}}
          </span>
        </sv>
        <sv label="Net Total">
          <strong class="float-right">
            {{data.netTotalAmount|currency:data.currencyCode}}
          </strong>
        </sv>
      </sv-container>
      <div>
      </div>
    </nz-spin>
  </ng-container>
</nz-modal>
